namespace RioERP.Users {
    export interface CustomersEmailForm {
        Subject: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        RowIds: Serenity.StringEditor;
    }

    export class CustomersEmailForm extends Serenity.PrefixedContext {
        static formKey = 'Users.CustomersEmail';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CustomersEmailForm.init)  {
                CustomersEmailForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CustomersEmailForm, [
                    'Subject', w0,
                    'Description', w0,
                    'RowIds', w0
                ]);
            }
        }
    }
}
